import {QuizSessionFeedback} from '@cp/model';
import {updateDoc} from 'firebase/firestore';
import getQuizSessionDoc from './getQuizSessionDoc';
import {getQuizSessionDocRef} from './getQuizSessionDocRef';

export default async function updateQuizSessionFeedbackDoc(
  uid: string,
  sessionId: string,
  feedback: QuizSessionFeedback,
): Promise<void> {
  const session = await getQuizSessionDoc(uid, sessionId);
  if (!session) {
    throw new Error('Session not found');
  }
  if (!session.endedAt) {
    throw new Error('Session must be completed before feedback');
  }
  if (session.feedback) {
    throw new Error('Session feedback already submitted');
  }

  const ref = getQuizSessionDocRef(uid, sessionId);
  await updateDoc(ref, {feedback});
}
